import { getLinkHrefUrl } from "./../../_shared/link/get-link-href-url.js";
import { normalizeHref } from "./../../_shared/link/normalize-href.js";
import { getAbsoluteUrl } from "./../../_shared/media/get-absolute-url.js";
import { deriveWixMediaId } from "./derive-wix-media-id.js";
const FALLBACK_DIMENSION = 1;
const normalizeGalleryItems = ({
  items,
  nodeId,
  disableDownload = false,
  relValue,
  anchorTarget,
  baseUrl
}) => items.flatMap((item, index) => {
  const title = item.title || void 0;
  const alt = item.altText || title || "";
  if (item.image?.media) {
    const source = normalizeSource(item.image.media, "image");
    if (!source) {
      return [];
    }
    const dimensions = normalizeDimensions(item.image.media);
    return [
      {
        type: "image",
        id: `gallery-item:${nodeId}:${index}`,
        sourceIndex: index,
        title,
        alt,
        width: dimensions.width,
        height: dimensions.height,
        disableDownload,
        source,
        link: normalizeLink(item.image.link, relValue, anchorTarget, baseUrl)
      }
    ];
  }
  if (item.video?.media) {
    const source = normalizeSource(item.video.media, "video");
    if (!source) {
      return [];
    }
    const dimensions = normalizeDimensions(item.video.media);
    return [
      {
        type: "video",
        id: `gallery-item:${nodeId}:${index}`,
        sourceIndex: index,
        title,
        alt,
        width: dimensions.width,
        height: dimensions.height,
        disableDownload,
        source,
        poster: item.video.thumbnail ? normalizeSource(item.video.thumbnail, "image") : void 0
      }
    ];
  }
  return [];
});
const normalizeSource = (media, type) => {
  const sourceValue = media.src?.url || media.src?.id;
  if (!sourceValue?.trim()) {
    return void 0;
  }
  const mediaId = media.src?.id || deriveWixMediaId(sourceValue);
  return {
    url: getAbsoluteUrl(sourceValue, type),
    ...mediaId ? { id: mediaId } : {},
    ...isPositiveFinite(media.width) ? { width: media.width } : {},
    ...isPositiveFinite(media.height) ? { height: media.height } : {}
  };
};
const normalizeDimensions = (media) => ({
  width: isPositiveFinite(media.width) ? media.width : FALLBACK_DIMENSION,
  height: isPositiveFinite(media.height) ? media.height : FALLBACK_DIMENSION
});
const isPositiveFinite = (value) => typeof value === "number" && Number.isFinite(value) && value > 0;
const normalizeLink = (link, relValue, anchorTarget, baseUrl) => {
  if (!link) {
    return void 0;
  }
  const normalizedUrl = link.url ? normalizeHref(link.url) : void 0;
  const url = normalizedUrl || getLinkHrefUrl(link.anchor ? { anchor: link.anchor } : { url: link.url }, baseUrl);
  if (!url) {
    return void 0;
  }
  const target = link.target ? `_${link.target.toLowerCase()}` : anchorTarget || "_self";
  const rel = link.rel ? normalizeRel(link.rel) : relValue || "noopener";
  return { url, target, rel };
};
const normalizeRel = (rel) => {
  const values = ["noopener"];
  if (rel.nofollow) {
    values.push("nofollow");
  }
  if (rel.sponsored) {
    values.push("sponsored");
  }
  if (rel.ugc) {
    values.push("ugc");
  }
  if (rel.noreferrer !== false) {
    values.push("noreferrer");
  }
  return values.join(" ");
};
export {
  normalizeGalleryItems
};
//# sourceMappingURL=normalize-gallery-items.js.map
